<template>
	<div class="container-wrapper">
		<!-- <go-back v-if="!$store.state.isMobile" v-model="banner" url="/admin/user-list" label="Back" :backToList="true"></go-back> -->
		<b-container class="global-settings-container container" v-if="loaded">


			<b-row>
				<b-col>
					<h1 class="page-title">Edit Callout</h1>
					<b-row>
						<b-col>
							<b-form-group label="Callout Template"
								:state="banner.template.status"
								:invalid-feedback="banner.template.invalidMessage"
							>
							<b-input-group>
								<b-form-select v-model="banner.template.value"
									@input="banner.template.resetStatus()"
									:state="banner.template.status"
									:options="PublicBanner.getTypes"
									value-field="value"
									text-field="text"
									inline
								></b-form-select>
							</b-input-group>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col class="editor-col">
							<b-form-group label="English Content"
								:state="banner.content.status"
								:invalid-feedback="banner.content.invalidMessage"
							>
							<wysiwyg v-model="banner.content.value"></wysiwyg>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col class="editor-col">
							<b-form-group label="French Content"
								:state="banner.contentFr.status"
								:invalid-feedback="banner.contentFr.invalidMessage"
							>
							<wysiwyg v-model="banner.contentFr.value"></wysiwyg>
							</b-form-group>
						</b-col>
					</b-row>


					<b-row>
						<b-col class="save__banner">
							<b-button variant="primary" type="button" @click="onSubmitDraft" :disabled="saving">Save Draft</b-button>
							<b-button class="ml-1" variant="secondary" type="button" @click="onPreview" :disabled="saving">Save &amp; Preview</b-button>
							<b-button class="ml-1" variant="secondary" type="button" @click="onPreviewFr" :disabled="saving">Save &amp; Preview French</b-button>
							<b-button class="ml-1" variant="danger" type="button" @click="onPublish" :disabled="saving">Publish to Live</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<b-row class="mt-4">
				<b-col>
					<hr>
					<h2>Published Callout</h2>
					<strong>English</strong>
					<b-row>
						<b-col class="published-banner" v-html="curBanner">
						</b-col>
					</b-row>
					<strong>French</strong>
					<b-row>
						<b-col class="published-banner" v-html="curBannerFr">
						</b-col>
					</b-row>

					<b-row class="mt-2" v-if="false">
						<b-col>
							<b-form-group label="Show Callouts">
								<b-form-checkbox :check="curBannerActive.value == 1" v-model="curBannerActive.value" key="showBanner" :unchecked-value="0" :value="1" name="showBanner">
									<span>Show callout on public CoW website</span>
								</b-form-checkbox>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col>
							<div v-if="curBannerActive.value == 1">Callouts are <strong>SHOWN</strong> on the public website.</div>
							<div v-if="curBannerActive.value == 0">Callouts are <strong>HIDDEN</strong> on the public website.</div>
						</b-col>
					</b-row><br/>

					<b-row>
						<b-col class="save__banner">
							<b-button v-if="curBannerActive.value == 1" variant="primary" type="button" @click="onHideBanner" :disabled="saving">HIDE Callouts on Public website</b-button>
							<b-button v-if="curBannerActive.value == 0" variant="primary" type="button" @click="onShowBanner" :disabled="saving">SHOW Callouts on Public website</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import PublicBanner from "../../../models/PublicBanner";
import Vue from 'vue';
import BootstrapField from '../../../utility/BootstrapField';

export default {
	name: 'BannerEdit',
	docTitle() {
		return `Edit Callout - Lane Closures`;
	},

	components: {
	},
	data() {
		return {
			PublicBanner,
			banner: null,
			loaded: false,
			saving: false,
			previewUrlEn:null,
			previewUrlFr:null,
			curBanner: "",
			curBannerFr: "",
			curBannerActive: new BootstrapField({
				value: 0,
				require: true,
			}),
		};
	},
	mounted() {
		this.fetchBannerSettings();
		this.fetchLatestBanner();
		this.fetchCurrentBanner();
	},
	methods: {
		fetchBannerSettings() {
			Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/public-callout/settings`,
				params: {r: Math.round(Math.random() * Math.pow(10, 6))}
			}).then((res) => {
				this.previewUrlEn = res.data.previewUrlEn;
				this.previewUrlFr = res.data.previewUrlFr;
			}).catch((err) => {
			});
		},

		fetchLatestBanner() {
			this.loaded = false;
			Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/public-callout/latest`,
				params: {id: 1, r: Math.round(Math.random() * Math.pow(10, 6))}
			}).then((res) => {
				this.banner = new PublicBanner(res.data);
				this.loaded = true;
			}).catch((err) => {
				this.loaded = false;
			});
		},
		fetchCurrentBanner() {
			Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/public-callout/current/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
			}).then((res) => {
				const bannerData = res.data;
				this.curBanner = bannerData.callout;
				this.curBannerFr = bannerData.calloutFr;
				this.curBannerActive.value = bannerData.isActive;
			}).catch((err) => {
				this.loaded = false;
			});
		},

		saveDraft() {

			this.saving = true;
			return Vue.prototype.$http({
				method: 'post',
				url: `${this.$store.state.apiUrl}/public-callout/draft/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: this.banner.getValue(),
			}).then((res) => {
				this.banner = new PublicBanner(res.data);
				this.saving = false;
			}).catch((err) => {
				this.saving = false;
			});
		},
		publishBanner() {
			this.saving = true;

			return Vue.prototype.$http({
				method: 'post',
				url: `${this.$store.state.apiUrl}/public-callout/publish/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: this.banner.getValue(),
			}).then((res) => {
				this.banner = new PublicBanner(res.data.latest);
				const bannerData = res.data.published;
				this.curBanner = bannerData.callout;
				this.curBannerFr = bannerData.calloutFr;
				this.curBannerActive.value = bannerData.isActive;

				this.saving = false;
			}).catch((err) => {
				this.saving = false;
			});
		},
		previewBanner() {
			window.open(
			this.previewUrlEn + "?calloutid=1",
				'_blank'
			);
		},
		previewBannerFr() {
			window.open(
			this.previewUrlFr + "?calloutid=1",
				'_blank'
			);
		},

		onSubmitDraft() {
			if (!this.validateBanner()) return;
			this.saveDraft();
		},
		async onPreview() {
			if (!this.validateBanner()) return;
			await this.saveDraft();
			this.previewBanner();
		},
		async onPreviewFr() {
			if (!this.validateBanner()) return;
			await this.saveDraft();
			this.previewBannerFr();
		},
		onPublish() {
			if (!this.validateBanner()) return;
			this.publishBanner();
		},
		onUpdate() {
			this.saving = true;
			const dummyData = this.banner.getValue();
			dummyData.isActive = this.curBannerActive.getValue();
			return Vue.prototype.$http({
				method: 'post',
				url: `${this.$store.state.apiUrl}/public-callout/update/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: dummyData,
			}).then((res) => {
				this.saving = false;
			}).catch((err) => {
				this.saving = false;
			});
		},

		onHideBanner() {
			this.saving = true;
			const dummyData = this.banner.getValue();
			dummyData.isActive = 0;
			return Vue.prototype.$http({
				method: 'post',
				url: `${this.$store.state.apiUrl}/public-callout/update/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: dummyData,
			}).then((res) => {
				this.curBannerActive.value = 0;
				this.saving = false;
			}).catch((err) => {
				this.saving = false;
			});
		},

		onShowBanner() {
			this.saving = true;
			const dummyData = this.banner.getValue();
			dummyData.isActive = 1;
			return Vue.prototype.$http({
				method: 'post',
				url: `${this.$store.state.apiUrl}/public-callout/update/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: dummyData,
			}).then((res) => {
				this.curBannerActive.value = 1;
				this.saving = false;
			}).catch((err) => {
				this.saving = false;
			});
		},


		validateBanner() {
			const bannerObject = this.banner;
			if (!bannerObject.validate()) {
				return false;
			}

			return true;
		},

		fetchAllBannerTemplate() {
			Vue.prototype.$http({
				methods: 'put',
				url: `${this.$store.state.apiUrl}/public-callout/templates/?r=${Math.round(Math.random() * Math.pow(10, 6))}`
			}).then((res) => {

			}).catch((err) => {

			});
		},
	}
}
</script>

<style lang="scss" scoped>
	.published-banner {
		/deep/ .alert {
			border-width: 0;
			border-left-width: 0.25rem;

			&.alert-info {
				color: #00262d;
				background-color: #ebfafc;
				border-color: #00bfdf;
			}
			&.alert-warning {
					color: #332505;
					background-color: #fff9ed;
					border-color: #ffb71b;
			}
			&.alert-danger {
				color: #29070a;
				background-color: #fbedef;
				border-color: #ce2334;
			}

			p.lead {
				margin-bottom: 0;
				font-weight: 400;
			}
		}
	}
</style>
<style lang="scss">
	.editor-col {
		h1,h2,h3,h4,h5,h6 {
			color: black;
		}
		h1 {
			font-size: 38px;
		}
		h2 {
			font-size: 32px;
			font-weight: 500;
		}
		h3 {
			font-size: 26px;
			font-weight: 500;
		}
		h4 {
			font-size: 24px;
			font-weight: 600;
		}
		h5 {
			font-size: 22px;
			font-weight: 600;
		}
		h6 {
			font-size: 18px;
			font-weight: 600;
		}
	}
	.published-banner {
		h1,h2,h3,h4,h5,h6 {
			color: black;
		}
		h1 {
			font-size: 38px;
		}
		h2 {
			font-size: 32px;
			font-weight: 500;
		}
		h3 {
			font-size: 26px;
			font-weight: 500;
		}
		h4 {
			font-size: 24px;
			font-weight: 600;
		}
		h5 {
			font-size: 22px;
			font-weight: 600;
		}
		h6 {
			font-size: 18px;
			font-weight: 600;
		}
	}
</style>
